import { Box, Container, Text, HStack, VStack, useBreakpointValue, chakra } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import Navigation from "../Navigation";

const Layout = ({ children }) => {

	const isWideScreen = useBreakpointValue({ base: false, md: true });
	const location = useLocation();




	return (
		<Box minHeight="100vh" display="flex" flexDirection="column" overflow="hidden">
			<Box as="header" color="black" padding={2}>
				<Container maxW="1400px">
					{isWideScreen ? (
						<HStack
							spacing={4}
							justify="space-between"
							align="center"
							wrap="wrap"
						>
							<Box>
								<Link to="/">
									<Text fontSize={30}>Scrollstat
										<chakra.span color={"red"} fontSize="15px" display="inline-block" verticalAlign="text-bottom" pl="5px">
											(made with love)
										</chakra.span>
									</Text>
								</Link>
							</Box>
							<Box flex="1" display="flex" justifyContent="flex-end">
								<Navigation />
							</Box>
						</HStack>
					) : (
						<VStack align="center" mt={4}>
							<Box>
								<Link to="/">
									<Text fontSize={30}>Scrollstat</Text>
								</Link>
							</Box>
							<Box width="100%">
								<Navigation />
							</Box>
						</VStack>
					)}
				</Container>
			</Box>

			<Box as="main" flex="1" padding={4} overflowY="auto" pb="80px">
				<Container maxW="1400px" height="100%">
					{children}
				</Container>
			</Box>
			{/* <RightSidebar /> */}

		</Box>
	);
};

export default Layout;
